// Renders guide HTML produced by MarkdownRenderer, which strips raw HTML and
// sanitizes the result server-side. Styling comes from @tailwindcss/typography,
// mapped onto the design tokens so guides look like the rest of the platform.
export default function GuideBody({ html }: { html: string }) {
  return (
    <div
      className={[
        "prose max-w-none",
        "prose-headings:font-display prose-headings:text-ink prose-headings:font-bold",
        "prose-p:text-ink-muted prose-li:text-ink-muted",
        "prose-strong:text-ink",
        "prose-a:text-link prose-a:font-bold",
        "prose-code:text-ink prose-code:bg-surface-alt prose-code:px-1 prose-code:py-0.5 prose-code:rounded-sm prose-code:before:content-none prose-code:after:content-none",
        "prose-pre:bg-surface-alt prose-pre:text-ink prose-pre:border-2 prose-pre:border-line/20",
        "prose-blockquote:border-l-viking prose-blockquote:text-ink-muted prose-blockquote:not-italic",
        "prose-hr:border-line/20",
        "prose-table:text-ink-muted prose-th:text-ink",
      ].join(" ")}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
